import React, { useReducer, useEffect, useContext, useRef} from "react";
import nivel4Context from "./nivel4Context";
import { getAllNivel4s, addNivel4, updateNivel4, deleteNivel4, updatePositioning, deleteNivel4AndChildren } from "../../api/nivel4";
import nivel4Reducer from "./nivel4Reducer";
import authContext from "../authentication/authContex";


//Types
import { 
    ACTUALIZAR_LIST_NIVEL4,
  } from "./nivel4Actions";
import { SocketContext } from "../socket/socket";
import Swal from "sweetalert2";


const Nivel4State = props =>{
    
    const initialState = {
        nivel4List: null
     };
    
    const [state, dispatch] = useReducer(nivel4Reducer, initialState);
    
    const auContext = useContext(authContext);
    const {verificarTenant, usuario} = auContext;
    const server = useContext(SocketContext);
    const nivel4ListRef = useRef(state.nivel4List);

    const actualizarNivel4List = async () => {
        try{
            const resp = await getAllNivel4s();
            let nivel4 = resp.data.data;
            nivel4 = nivel4.map((lv4,i) => ({...lv4, position: lv4.position ?? i + 1})); 
            nivel4ListRef.current = nivel4;
            dispatch({
                type: ACTUALIZAR_LIST_NIVEL4,
                payload: nivel4
            });
            
            return nivel4;
        }catch(err){
            console.log(err)
        }

    };

    const agregarNivel4 = async (datos) => {
        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addnivel4
            const resp = await addNivel4(datos);
            const nivel4 = resp.data.data;
            return {saved:true, lv4Saved: nivel4};
        }catch(err){
            let msg = err.response?.data?.message ?? 'Error desconocido'
            let customMsg = msg.includes("duplicate key error") ? 'Código o Nombre se está repitiendo.' : msg;
            return {saved: false, msg: customMsg};  
        }   
    };

    const modificarNivel4 = async (dato) => {
        try{
            
            const resp = await updateNivel4(dato);
            const activo = resp.data.data;
            
            return activo;
        }catch(err){
            console.log(err)
            return null;
        }
    }

    const eliminarNivel4 = async (id) => {
        try{
            
            const resp = await deleteNivel4(id);
            const activo = resp.data.data;
            
            return activo;
        }catch(err){
            console.log(err)
        }
    }

    const eliminarNivel4eHijos = async(id, deleteActivesToo = false, from = '') => {
        try {

            const resp = await deleteNivel4AndChildren(id, deleteActivesToo);
            const nivel4 = resp.data.data;
            const swalConfig = {title:'Eliminado!', html: nivel4, icon:'success'};
            if(from === 'TreeActivo') return swalConfig;
            Swal.fire(swalConfig);
            return nivel4;
        } catch (error) {
            console.log(error)
            const errorConfig = {title:'Ops!', text: error?.response?.data?.data ?? 'Error al eliminar', icon:'error'};
            if(from === 'TreeActivo') return errorConfig;
            if(error.response?.status == 401) Swal.fire(errorConfig);
        }
    }

    const updatePositionLv4 = async (updates) => {
        let lvs4Updated = nivel4ListRef.current ?? [];
        lvs4Updated = lvs4Updated.map(a => {
            let lvFound = updates.find(upd => upd._id == a._id);
            return {
                ...a,
                position: lvFound ? lvFound.position : a.position
            }
        });
        nivel4ListRef.current = lvs4Updated;
        await updatePositioning(updates);
        dispatch({
            type: ACTUALIZAR_LIST_NIVEL4,
            payload: lvs4Updated
        });
    }

    useEffect(() => {
        if(usuario != null) actualizarNivel4List();
    },[usuario])

    useEffect(()=>{
        if(server){
            server.on('nivel4sUpdated', ({tenantId}) => {
                console.log("Recibo el evento del Real Time Server nivel4sUpdated");
                let update = verificarTenant(tenantId);
                if(update){
                    actualizarNivel4List();
                }
            });

            server.on('nivel4Eliminated', ({tenantId}) => {
                let update = verificarTenant(tenantId);
                if(update){
                    actualizarNivel4List();
                }
            })

            return () => {
                server.off('nivel4sUpdated');
                server.off('nivel4Eliminated');
            }
        }
    },[server])

    return(
        <nivel4Context.Provider
            value={{
                nivel4List: state.nivel4List,
                actualizarNivel4List,
                agregarNivel4,
                modificarNivel4,
                eliminarNivel4,
                eliminarNivel4eHijos,
                updatePositionLv4
            }}
        >
            {props.children}
        </nivel4Context.Provider>
    )

}

export default Nivel4State;